import { grey } from 'src/theme/palette';

// ─── Legacy exports (kept for backward compatibility if referenced elsewhere) ───
export const tableHeaderStyle = (isLight) => ({
    width: '50%',
    backgroundImage: isLight ? 'linear-gradient(rgb(244, 246, 248) 0%, rgb(244, 246, 248) 100%)' : '#161C24',
    padding: '16px'
});
export const tableCellStyle = {
    width: '50%',
    padding: '16px',
    wordBreak: 'break-all'
};
export const typeIconBGStyle = {
    width: '42px',
    height: '43.24px',
    bgcolor: 'rgba(255,108,64,0.24)',
    borderRadius: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 'auto'
};
export const referralIconBGStyle = {
    width: '42px',
    height: '43.24px',
    bgcolor: 'rgba(224,45,105,0.24)',
    borderRadius: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 'auto'
};
export const textStyle = {
    fontSize: '1rem',
    fontWeight: '400',
    color: '#212B36',
    lineHeight: '22px',
    textAlign: 'center',
    mt: '8px'
};
export const sourceTopCardStyle = {
    mb: '24px',
    p: '16px',
    display: 'flex',
    justifyContent: 'space-between'
};

// ─── Modern Analytics-Style Exports ───

export const sourceCardsRow = {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '16px',
    mb: 3,
    '@media(max-width: 600px)': {
        gridTemplateColumns: '1fr',
    },
};

export const sourceCard = (accentColor) => ({
    bgcolor: '#fff',
    borderRadius: '16px',
    p: '24px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    borderLeft: `4px solid ${accentColor || '#3b82f6'}`,
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
});

export const sourceCardHeader = {
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
};

export const sourceCardIconBox = (bgColor) => ({
    width: '44px',
    height: '44px',
    minWidth: '44px',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    bgcolor: bgColor || 'rgba(59, 130, 246, 0.12)',
});

export const sourceCardLabel = {
    fontSize: '12px',
    fontWeight: 600,
    color: '#64748b',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
};

export const sourceCardValue = {
    fontSize: '18px',
    fontWeight: 700,
    color: '#1e293b',
    lineHeight: '24px',
};

export const metadataContainer = {
    bgcolor: '#fff',
    borderRadius: '16px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    overflow: 'hidden',
};

export const metadataHeader = {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    p: '20px 24px',
    borderBottom: '1px solid #e2e8f0',
};

export const metadataTitle = {
    fontSize: '18px',
    fontWeight: 700,
    color: '#1e293b',
};

export const metadataCount = {
    display: 'inline-flex',
    alignItems: 'center',
    bgcolor: '#f1f5f9',
    borderRadius: '20px',
    px: 1.5,
    py: 0.25,
    fontSize: '12px',
    fontWeight: 600,
    color: '#64748b',
};

export const metadataTableHead = {
    display: 'flex',
    bgcolor: '#f8fafc',
    borderBottom: '1px solid #e2e8f0',
};

export const metadataTableHeadCell = {
    width: '50%',
    py: 1.5,
    px: 3,
    fontSize: '12px',
    fontWeight: 600,
    color: '#64748b',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
};

export const metadataTableRow = (isLight) => ({
    display: 'flex',
    borderBottom: '1px solid',
    borderColor: isLight ? '#f1f5f9' : 'rgba(145, 158, 171, 0.12)',
    transition: 'background-color 0.15s ease',
    '&:hover': {
        bgcolor: isLight ? '#f8fafc' : 'rgba(145, 158, 171, 0.08)',
    },
    '&:last-child': {
        borderBottom: 'none',
    },
});

export const metadataTableKey = {
    width: '50%',
    py: 2,
    px: 3,
    fontSize: '14px',
    fontWeight: 600,
    color: '#334155',
    wordBreak: 'break-word',
};

export const metadataTableValue = {
    width: '50%',
    py: 2,
    px: 3,
    fontSize: '14px',
    fontWeight: 400,
    color: grey[600],
    wordBreak: 'break-word',
};

export const emptyStateBox = {
    textAlign: 'center',
    py: 6,
    px: 3,
};

export const emptyStateText = {
    fontSize: '15px',
    color: '#94a3b8',
    mt: 1.5,
};
